<template>
  <v-container
    id="requisite"
    tag="section"
  >
    <base-card
      color="rgba(0, 0, 0, 0)"
      class="pa-3"
    >
      <v-container
        grid-list-xl
        pa-0
      >
        <v-layout wrap>
          <v-flex
            xs12
          >
            <base-subheading>Реквизиты</base-subheading>
            <v-list class="transparent" v-if="!isMobile">
              <v-list-tile>
                <v-list-tile-title>Получатель платежа</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.recipient}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>Адрес получателя</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.address}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>ОГРН</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.attr_1}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>ИНН</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.attr_2}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>КПП</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.attr_3}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>Расчетный счет</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.recipient_account}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>БИК</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.bank_id}}
                </v-list-tile-sub-title>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-title>К/С</v-list-tile-title>
                <v-list-tile-sub-title>
                  {{about.bank_account}}
                </v-list-tile-sub-title>
              </v-list-tile>
            </v-list>
            <div v-else>
              <span><b>Получатель платежа:</b></span><br>
              <span>{{about.recipient}}</span><br>
              <span><b>Адрес получателя:</b></span><br>
              <span>{{about.address}}</span><br>
              <span><b>ОГРН:</b></span><br>
              <span>{{about.attr_1}}</span><br>
              <span><b>ИНН:</b></span><br>
              <span>{{about.attr_2}}</span><br>
              <span><b>КПП:</b></span><br>
              <span>{{about.attr_3}}</span><br>
              <span><b>Расчетный счет:</b></span><br>
              <span>{{about.recipient_account}}</span><br>
              <span><b>БИК:</b></span><br>
              <span>{{about.bank_id}}</span><br>
              <span><b>К/С:</b></span><br>
              <span>{{about.bank_account}}</span><br>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </base-card>
  </v-container>
</template>

<styles lang='css'>
  #requisite .v-list__tile {
    height: auto;
  }
  #requisite .v-list__tile__title,
  #requisite .v-list__tile__sub-title {
    height: auto;
    line-height: inherit;
    white-space: normal;
  }
</styles>

<script>
  import axios from 'axios'

  export default {
    data: function() {
      return {
        about: {},
        isMobile: false
      }
    },
    beforeDestroy () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true })
      }
    },
    mounted () {
      this.onResize();
      window.addEventListener('resize', this.onResize, { passive: true });
      axios.get('/static/data/about.json')
        .then(response => {
          this.about = response.data
        }).catch(error => {
          console.log(error)
        });
    },
    methods: {
      onResize () {
        this.isMobile = window.innerWidth < 600;
      }
    }
  }
</script>
